const MINUTE_MS = 60_000;
const HOUR_MS = 60 * MINUTE_MS;
const DAY_MS = 24 * HOUR_MS;

// en-GB in current ICU abbreviates September as "Sept", so the names are fixed here.
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

const startOfDay = (date: Date): number => new Date(
  date.getFullYear(),
  date.getMonth(),
  date.getDate(),
).getTime();

// Rounded because a day that crosses a daylight saving change is 23 or 25 hours long.
const calendarDaysBetween = (earlier: Date, later: Date): number => Math.round(
  (startOfDay(later) - startOfDay(earlier)) / DAY_MS,
);

const formatDayMonth = (date: Date): string => `${date.getDate()} ${MONTHS[date.getMonth()]}`;

const formatSessionTime = (iso: string, now: Date = new Date()): string => {
  const created = new Date(iso);
  const elapsedMs = now.getTime() - created.getTime();

  if (elapsedMs < MINUTE_MS) return 'Just now';
  if (elapsedMs < HOUR_MS) return `${Math.floor(elapsedMs / MINUTE_MS)} min`;

  const days = calendarDaysBetween(created, now);
  if (days === 0) return `${Math.floor(elapsedMs / HOUR_MS)} h`;
  if (days === 1) return 'Yesterday';
  if (days < 7) return WEEKDAYS[created.getDay()];
  if (created.getFullYear() === now.getFullYear()) return formatDayMonth(created);
  return `${formatDayMonth(created)} ${created.getFullYear()}`;
};

export default formatSessionTime;
